import { render, staticRenderFns } from "./ChannelBroadcast.vue?vue&type=template&id=1116eae1"
import script from "./ChannelBroadcast.vue?vue&type=script&lang=js"
export * from "./ChannelBroadcast.vue?vue&type=script&lang=js"
import style0 from "./ChannelBroadcast.vue?vue&type=style&index=0&id=1116eae1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports